<template>
    <div v-if="show" class="replay-overlay" @click="$emit('overlay-click', $event)">
        <template>
            <div v-if="!recordedReplayReady" class="replay-overlay__box d-flex align-items-center justify-content-center">
                <div class="d-flex align-items-center">
                    <b-spinner small class="mr-2" />
                    <span>We verwerken je video {{ recordedReplayPrepPercent !== null ? (recordedReplayPrepPercent + '%') : '…' }}</span>
                </div>
            </div>
            <template v-else>
                <canvas ref="recordedReplayCanvas" class="output_canvas"></canvas>
                <button
                    v-if="!recordedReplayPlaying"
                    type="button"
                    class="replay-overlay__play"
                    @click.stop="$emit('play-single')">
                    <font-awesome-icon :icon="['fas','play']" />
                </button>
            </template>
        </template>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ReplayOverlay extends Vue {
    @Prop({ type: Boolean, required: true }) show!: boolean;
    @Prop({ type: Boolean, required: true }) recordedReplayReady!: boolean;
    @Prop({ type: Boolean, required: true }) recordedReplayPlaying!: boolean;
    @Prop({ type: Number, default: null }) recordedReplayPrepPercent!: number | null;

    private hasEmittedCanvasReady: boolean = false;

    private emitCanvasIfReady() {
        if (!this.show || !this.recordedReplayReady) {
            this.hasEmittedCanvasReady = false;
            return;
        }
        this.$nextTick(() => {
            const el = this.$refs['recordedReplayCanvas'] as HTMLCanvasElement | undefined;
            if (el && !this.hasEmittedCanvasReady) {
                this.hasEmittedCanvasReady = true;
                this.$emit('recorded-replay-canvas-ready', el);
            }
        });
    }

    mounted() {
        this.emitCanvasIfReady();
    }

    updated() {
        this.emitCanvasIfReady();
    }
}
</script>

<style lang="scss" scoped>
.output_canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    pointer-events: none;
    object-fit: cover;
}

.replay-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.replay-overlay__box {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}

.replay-overlay__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: none;
    background: rgba(0,0,0,0.45);
    color: #fff;
    cursor: pointer;
}
.replay-overlay__play:hover {
    background: rgba(0,0,0,0.6);
}
</style>

 